import {
  getAllPmoDetails,
  getAllPmoProps,
} from '../../../../types/ProjectManagement/PmoConfiguration/PmoConfigurationTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import { pmoConfigurationApiConfig, AllowedHttpMethods } from '../../apiList'

const getAllPMO = async (data: getAllPmoProps): Promise<getAllPmoDetails> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: pmoConfigurationApiConfig.getAllPMO,
    method: AllowedHttpMethods.get,
    params: {
      startIndex: data?.startIndex,
      endIndex: data?.endIndex,
      search: data?.search,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const addPmoConfig = async (empId: number): Promise<number | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: pmoConfigurationApiConfig.addPmoConfig,
    method: AllowedHttpMethods.post,
    params: {
      empId,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const deletePmoConfig = async (pmoId: number): Promise<number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: pmoConfigurationApiConfig.deletePmoConfig,
    method: AllowedHttpMethods.delete,
    params: {
      pmoId,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const isCheckPMO = async (empId: number): Promise<boolean> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: pmoConfigurationApiConfig.isPMO,
    method: AllowedHttpMethods.get,
    params: {
      empId,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const PmoConfigurationApi = {
  getAllPMO,
  addPmoConfig,
  deletePmoConfig,
  isCheckPMO,
}

export default PmoConfigurationApi
